export interface ShellCatalogContext {
    categoryPath?: string;
    productPath?: string;
    brandPath?: string;
}

const sessionStorageKey = "shellCatalogContext";

export const setShellCatalogContext = (context: ShellCatalogContext) => {
    try {
        window.sessionStorage.setItem(sessionStorageKey, JSON.stringify(context));
    } catch {
        // session storage can be unavailable, the catalog context is not important enough to fail over it
    }
};

export const getShellCatalogContext = (): ShellCatalogContext => {
    try {
        return JSON.parse(window.sessionStorage.getItem(sessionStorageKey) || "{}");
    } catch {
        return {};
    }
};
